export const ExcludedEmails = [
  "shahrozt20@gmail.com",
  "mshehrozsajjad@gmail.com",
  "christian.diller@gmx.de",
  "lucasjacobson3@gmail.com",
  "engr.awaisshafique@gmail.com",
  "awais.shafique03@gmail.com",
  "sricharanchiruvolu@gmail.com",
  "shivangi.tum@gmail.com",
  "anna.tyrkich@gmail.com",
  "annaworkingaddress@gmail.com",
  "april.bachhuber@gmail.com",
  "jewefow839@naobk.com",
  "aprilbachhuberwork@gmail.com",
  "user1@mailinator.com", // account used for testing
  "renefilip@mail.com",
  "shahrukhjqureshi@gmail.com",
  "egeyaygin@hotmail.com",
  "egeyaygin5@gmail.com",
]

export const ExcludedDomains = [
  "fa9r.com",
  "beyondpresence.ai",
  "mailinator.com",
]
